module.exports = __webpack_public_path__ + "static/media/portisIcon.9e0c4a08.png";